"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "p-private-wall"
  }, [_c('header', {
    staticClass: "p-top-nav"
  }, [_c('button', {
    staticClass: "p-back-btn",
    on: {
      "click": function ($event) {
        return _vm.$emit('back');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" VOLVER AL MURO ")]), _c('button', {
    staticClass: "p-post-btn-header",
    on: {
      "click": function ($event) {
        _vm.showEditor = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" NUEVO POST ")])]), _vm.showEditor ? _c(_setup.PostEditor, {
    on: {
      "cancel": function ($event) {
        _vm.showEditor = false;
      },
      "publish": _vm.onPublish
    }
  }) : _vm._e(), _c('div', {
    staticClass: "p-profile-body"
  }, [_c('div', {
    staticClass: "p-banner",
    style: {
      background: _vm.user.bannerColor || '#ff00cc'
    }
  }), _c('div', {
    staticClass: "p-header-main"
  }, [_c('img', {
    staticClass: "p-avatar-large",
    attrs: {
      "src": _vm.user.avatar
    }
  }), _c('div', {
    staticClass: "p-meta"
  }, [_c('h2', [_vm._v(_vm._s(_vm.user.name) + " "), _c('span', {
    staticClass: "p-verify-tag"
  }, [_vm._v("PREMIUM")])]), _c('span', {
    staticClass: "p-handle-large"
  }, [_vm._v(_vm._s(_vm.user.handle))]), _c('div', {
    staticClass: "p-counters"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.user.posts || '1.2k'))]), _vm._v(" Publicaciones")]), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.user.likes || '8.5M'))]), _vm._v(" Me gusta")])])]), !_vm.isOwner ? _c('button', {
    staticClass: "p-sub-btn"
  }, [_vm._v("SUSCRIBIRSE")]) : _vm._e()]), _vm.isOwner ? _c('div', {
    staticClass: "p-profile-tabs"
  }, [_c('div', {
    staticClass: "p-tab-item",
    class: {
      active: _vm.currentTab === 'posts'
    },
    on: {
      "click": function ($event) {
        _vm.currentTab = 'posts';
      }
    }
  }, [_vm._v(" PUBLICACIONES ")]), _c('div', {
    staticClass: "p-tab-item",
    class: {
      active: _vm.currentTab === 'edit'
    },
    on: {
      "click": function ($event) {
        _vm.currentTab = 'edit';
      }
    }
  }, [_vm._v(" EDITAR PERFIL ")]), _c('div', {
    staticClass: "p-tab-item",
    class: {
      active: _vm.currentTab === 'integrations'
    },
    on: {
      "click": function ($event) {
        _vm.currentTab = 'integrations';
      }
    }
  }, [_vm._v(" INTEGRACIONES ")]), _c('div', {
    staticClass: "p-tab-item",
    class: {
      active: _vm.currentTab === 'verification'
    },
    on: {
      "click": function ($event) {
        _vm.currentTab = 'verification';
      }
    }
  }, [_vm._v(" VERIFICACION ")]), _c('div', {
    staticClass: "p-tab-item",
    class: {
      active: _vm.currentTab === 'automation'
    },
    on: {
      "click": function ($event) {
        _vm.currentTab = 'automation';
      }
    }
  }, [_vm._v(" AUTOMATIZACION ")]), _c('div', {
    staticClass: "p-tab-item",
    class: {
      active: _vm.currentTab === 'channels'
    },
    on: {
      "click": function ($event) {
        _vm.currentTab = 'channels';
      }
    }
  }, [_vm._v(" MIS CANALES ")])]) : _vm._e(), _c('div', {
    staticClass: "p-feed-container"
  }, [_vm.currentTab === 'posts' ? [!_vm.isOwner ? _c('div', {
    staticClass: "p-grid-title"
  }, [_vm._v("PUBLICACIONES")]) : _vm._e(), _c('main', {
    staticClass: "global-wall"
  }, [_vm._l(_vm.filteredFeed, function (post, index) {
    return _c('div', {
      key: index,
      staticClass: "wall-post-card"
    }, [_c('div', {
      staticClass: "w-post-header"
    }, [_c('div', {
      staticClass: "w-post-user"
    }, [_c('div', {
      staticClass: "w-avatar-container"
    }, [_c('img', {
      attrs: {
        "src": post.userAvatar,
        "alt": "User"
      }
    }), _vm._m(0, true)]), _c('div', {
      staticClass: "w-user-text"
    }, [_c('span', {
      staticClass: "w-user-name"
    }, [_vm._v(_vm._s(post.userName))]), _c('span', {
      staticClass: "w-user-handle"
    }, [_vm._v(_vm._s(post.handle) + " • " + _vm._s(post.date))])])]), _vm._m(1, true)]), _c('div', {
      staticClass: "w-post-content"
    }, [_c('p', {
      staticClass: "w-description"
    }, [_vm._v(_vm._s(post.text))]), _c('div', {
      staticClass: "w-media-box",
      class: {
        'is-locked': post.locked
      }
    }, [_c('img', {
      attrs: {
        "src": post.thumbnail,
        "alt": "Post Media"
      }
    }), post.locked ? _c('div', {
      staticClass: "w-lock-overlay"
    }, [_vm._m(2, true), _c('button', {
      staticClass: "w-unlock-btn",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          post.locked = false;
        }
      }
    }, [_vm._v(" SUSCRÍBETE PARA VER ")])]) : _vm._e(), post.label ? _c('div', {
      staticClass: "w-media-tag"
    }, [_vm._v(_vm._s(post.label))]) : _vm._e()])]), _c('div', {
      staticClass: "w-post-footer"
    }, [_c('div', {
      staticClass: "w-actions-left"
    }, [_c('div', {
      staticClass: "w-action",
      on: {
        "click": function ($event) {
          post.likes++;
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-heart-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('span', [_vm._v(_vm._s(post.likes) + "k")])]), _c('div', {
      staticClass: "w-action"
    }, [_c('i', {
      staticClass: "fa fa-comment-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('span', [_vm._v(_vm._s(post.comments))])]), _vm._m(3, true)]), _vm._m(4, true)])]);
  }), _vm.filteredFeed.length === 0 ? _c('div', {
    staticClass: "no-posts"
  }, [_vm._v(" Todavía no hay publicaciones públicas. ")]) : _vm._e()], 2)] : _vm.currentTab === 'edit' ? [_c(_setup.ProfileEdit, {
    attrs: {
      "initial-data": _vm.user
    }
  })] : _vm.currentTab === 'integrations' ? [_c(_setup.Integrations, {
    attrs: {
      "user": _vm.user
    }
  })] : _vm.currentTab === 'verification' ? [_c(_setup.Verification)] : _vm.currentTab === 'automation' ? [_c(_setup.Automation)] : _vm.currentTab === 'channels' ? [_c(_setup.MyChannels)] : _vm._e()], 2)])], 1);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "w-check-badge"
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "w-more"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-h",
    attrs: {
      "aria-hidden": "true"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "w-lock-icon"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "w-action"
  }, [_c('i', {
    staticClass: "fa fa-retweet",
    attrs: {
      "aria-hidden": "true"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "w-action-right"
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]);
}];